// src/components/BusinessCardFlow/components/FinalScreen.js
import React from 'react';
import MyteLogo from '../assets/myte-logo.png';

export default function FinalScreen({ startNewBatch, sessionId }) {
  const containerStyle = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2rem',
    width: '100%',
    minHeight: '100vh',
    justifyContent: 'center'
  };
  const logoStyle = {
    width: '120px',
    marginBottom: '1rem'
  };
  const buttonStyle = {
    padding: '0.75rem 1.5rem',
    backgroundColor: '#4b5563',
    color: '#fff',
    border: 'none',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    marginLeft: '0.5rem'
  };

  const excelUrl = `/api/business-cards/download-excel?newOnly=true&sessionId=${encodeURIComponent(sessionId)}`;

  return (
    <div style={containerStyle}>
      <img src={MyteLogo} alt="Myte Logo" style={logoStyle} />
      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>All Done!</h2>
      <p style={{ marginBottom: '1rem' }}>
        Your contacts have been saved. Download your Excel file below.
      </p>
      <a
        href={excelUrl}
        style={{
          display: 'inline-block',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#1d4ed8',
          color: '#fff',
          borderRadius: '0.25rem',
          textDecoration: 'none'
        }}
      >
        Download Excel
      </a>
      <button onClick={startNewBatch} style={buttonStyle}>
        Start New Batch
      </button>
    </div>
  );
}
